export class AuthState {
    static login() {
        this.isAuthenticated = true;
    }
    static logout() {
        this.isAuthenticated = false;
    }
}
AuthState.isAuthenticated = false;
